import { apiFetch } from "./client";

export async function fetchAnalyticsConfig() {
  return apiFetch<{
    measurementId: string;
    adsConversionId?: string;
    adsLeadConversionLabel?: string;
  }>("/api/analytics/config");
}
